/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/s-nami-udobno'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import SnamiUdobno from '@routes/StaticPages/SnamiUdobno';

export const Route = createFileRoute('/s-nami-udobno')({
  component: () => (
    <CacheDataRoute component={SnamiUdobno} path='/s-nami-udobno' />
  )
});
